module.exports = __webpack_public_path__ + "img/mic.2a9c1099.svg";